import { Component, OnInit } from '@angular/core';
import { UnitsService } from 'src/app/services/units.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AddquotaComponent } from '../addquota/addquota.component';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { MainService } from 'src/app/services/main.service';
import { AddNoteComponent } from '../add-note/add-note.component';
import { UnitBlockComponent } from '../unit-block/unit-block.component';
import { ImportClientComponent } from '../import-client/import-client.component';
import { InvtaionComponent } from '../invtaion/invtaion.component';
import { AddCardComponent } from '../add-card/add-card.component';
import { ClientsService } from 'src/app/services/clients.service';
import { HttpClient } from '@angular/common/http';
import { VillageService } from 'src/app/services/village.service';
import { QrInvtationComponent } from '../qr-invtation/qr-invtation.component';

interface SelectProtected {
  readonly wrapperElement: HTMLDivElement | any;
}
@Component({
  selector: 'app-unit-details',
  templateUrl: './unit-details.component.html',
  styleUrls: ['./unit-details.component.css']
})
export class UnitDetailsComponent implements OnInit {
  unit_name: any;
  unitData: any;
  unitId: any;
  unit_clients: any = [];
  pipe = new DatePipe('en-US');
  mergeButonStatus = false;
  mergeStatus = false;
  transferStatus = false;
  Priority: any;
  Quota: any;
  Generated: any;
  Used: any;
  Remaining: any;
  unitsTransferInput: any;
  dateCurrent: any;
  blockClientTitle = 'Block';
  cleintsKeys: any;
  cardObject = {
    name: '',
    unitName: '',
    validFrom: '',
    validTo: '',
    type: '',
    image: '',
    image1: 'assets/images/teamCard.jpg',
    villageName: '',
    status : false
  };
  unit_client_data: any = [];
  imageBase64: any;
  imageBase641:any
  Filter_by = 'All';
  unitNameSearch: any;
  unitSearch_arr = [];
  constructor(
    private rest: UnitsService,
    public dialog: MatDialog,
    private _sanitizer: DomSanitizer,
    private mainService: MainService,
    private route: Router,
    private http: HttpClient,
    private valigeServ: VillageService,
    private clientService: ClientsService,
    private activeRouter: ActivatedRoute
  ) {}

  ngOnInit() {
    this.http
      .get('/assets/images/fouka.jpg', { responseType: 'blob' })
      .subscribe((res: any) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          var base64data = reader.result;
          this.imageBase64 = base64data;
          this.unit_data();
        };
        reader.readAsDataURL(res);
      });
      this.http
      .get('/assets/images/foukaone.jpg', { responseType: 'blob' })
      .subscribe((res: any) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          var base64data = reader.result;
          this.imageBase641 = base64data;
        };
        reader.readAsDataURL(res);
      });
    (this.dateCurrent = this.pipe.transform(new Date(), 'YYYY-MM-dd')),
      (this.unit_name = this.activeRouter.snapshot.paramMap.get('id'));
  }

  goUnit(name: any) {
    console.log(name);
    location.href = `pages/unit_details/${name.name}`;
  }
  village_List(id?: any) {
    this.valigeServ.villageList().subscribe((res: any) => {
      console.log(res);
      res.forEach((element: any) => {
        if (element.id == id) {
          this.cardObject.villageName = element.name;
        }
      });
    });
  }

  unit_data() {
    this.unit_client_data = [];
   
    this.rest.unitDetails(this.unit_name).subscribe((res: any) => {
      console.log('unit details', res);
      this.unitData = res.clients;
      this.village_List(res.village_id);
      console.log("sassa",Object.keys(res.clients));
      res.clients.unverified = res.unverified
      this.cleintsKeys = Object.keys(res.clients);
      this.cleintsKeys = this.cleintsKeys.reverse();
      this.cleintsKeys.forEach((element: any) => {
        console.log(res.clients[element]);
        this.unit_client_data.push(...res.clients[element]);
      });
      this.unitId = res.id;
      this.getQuota(this.dateCurrent);
      this.unit_client_data.forEach((element: any) => {
        if (element.images.length != 0) {
          element.images.forEach((item: any) => {
            item.image = this._sanitizer.bypassSecurityTrustUrl(
              `data:image/png;base64,` + item.image
            );
            if (item.image_type == 'personal_photo') {
              element.photo = item.image;
            }
          });
        } else {
          element.images.push({
            image: 'assets/images/avatar.png'
          });
        }
      });
      this.unit_clients = this.unit_client_data;
    });
  }

  getUserType(value: any) {
    if (value == 'all') {
      this.unit_clients = this.unit_client_data;
    } else {
      this.unit_clients = this.unitData[value];
    }
  }

  showQuotaAvalible: any;
  getDateToGetQuota(event: any) {
    let date = this.pipe.transform(event.value, 'YYYY-MM-dd');
    console.log(date);
    this.getQuota(date);
  }

  getQuota(date: any) {
    this.rest.getQuota(this.unitId, date).subscribe((res: any) => {
      if (res) {
        console.log(res);
        this.Priority = res.priority;
        if (this.Priority == 1) {
          this.Priority = 'Override ALL';
        } else if (this.Priority == 2) {
          this.Priority = 'High Priority';
        } else if (this.Priority == 3) {
          this.Priority = 'Standard';
        } else {
          this.Priority = 'Low Priority';
        }
        this.Quota = res.quota;
        this.Generated = res.generated;
        this.Remaining = res.remaining;
        this.Used = res.used;
        this.showQuotaAvalible = true;
      } else {
        this.showQuotaAvalible = false;
      }
    });
  }

  add_quota() {
    const dialogRef = this.dialog.open(AddquotaComponent, {
      width: '450px'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        result.unit_id = this.unitId;
        this.rest.addQuota(result).subscribe((res: any) => {
          console.log(res);
          this.mainService.SuccessToast('Quota Added');
          this.dateCurrent = this.pipe.transform(new Date(), 'YYYY-MM-dd');
          this.getQuota(this.dateCurrent);
        });
      }
    });
  }

  addClient() {
    this.route.navigate(['pages/add_client', this.unitId]);
  }

  editClient(value: any) {
    this.route.navigate(['pages/edit_client', this.unitId, value]);
  }
  viewClient(value: any) {
    this.route.navigate(['pages/view_client', this.unitId, value]);
  }
  openToMerge() {
    this.mergeButonStatus = !this.mergeButonStatus;
  }

  getSelectedItem(item: any) {
    item.status = !item.status;
  }

  clent_merge_arr: any = [];
  clickToMerage() {
    let counter = 0;
    this.unit_clients.forEach((element: any) => {
      if (element.status == true) {
        counter = counter + 1;
      }
    });
    if (counter >= 2) {
      const button: any = document.getElementById('btn');
      button.click();
    }
  }

  mergeClients() {
    let dumy: any = [];
    console.log(this.unit_clients);
    this.unit_clients.forEach((element: any) => {
      if (element.status == true) {
        dumy.push(element);
      }
    });

    const unique = dumy.filter(
      (obj: any, index: any) =>
        dumy.findIndex((item: any) => item.name === obj.name) === index
    );

    for (let i = 0; i < unique.length; i++) {
      for (let j = 0; j < dumy.length; j++) {
        if (unique[i].name == dumy[j].name && unique[i].id != dumy[j].id) {
          this.rest
            .mergeClient(unique[i].id, dumy[j].id)
            .subscribe((res: any) => {
              console.log(res);
              this.mainService.SuccessToast('Client Merged');
              this.unit_data();
            });
        }
      }
    }
  }

  transferUnitsOpen() {
    const button: any = document.getElementById('btn2');
    button.click();
  }

  transfer() {
    let data = {
      new_unit_id: this.newUnitId,
      old_unit_id: this.unitId
    };
    this.rest.transferUnit(data).subscribe((res: any) => {
      console.log(res);
      this.mainService.SuccessToast('Unit Transfer Succsess');
      this.unit_data();
    });
  }
  newUnitId: any;
  allunits: any = [];
  showlistUnits = false;
  getUnits(data: any) {
    this.showlistUnits = true;
    this.rest.searchunit(data.target.value).subscribe((res: any) => {
      console.log(res);
      this.allunits = res;
    });
    if (!data.target.value) {
      this.showlistUnits = false;
    }
  }

  getUnit(item: any) {
    this.showlistUnits = false;
    this.unitsTransferInput = item.name;
    this.newUnitId = item.id;
  }

  clientIdDeleted: any;
  openDeletClient(item: any) {
    this.clientIdDeleted = item.id;
    const button: any = document.getElementById('btn3');
    button.click();
  }

  DeleleClient() {
    this.rest.deleltClient(this.clientIdDeleted).subscribe((res: any) => {
      console.log(res);
      this.mainService.SuccessToast('Client deleted');
      this.unit_data();
    });
  }

  addNote(value: any, id: any) {
    let idOfClientOrUnit;
    if (id) {
      idOfClientOrUnit = id;
    } else {
      idOfClientOrUnit = this.unitId;
    }
    const dialogRef = this.dialog.open(AddNoteComponent, {
      width: '450px',
      data: { id: idOfClientOrUnit, name: value }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        if (value == 'unit') {
          result.unit_id = this.unitId;
          (result.expiry_date = this.pipe.transform(new Date(), 'YYYY-MM-dd')),
            console.log(result);
          this.rest.addNoteForUnit(result).subscribe((res: any) => {
            console.log(res);
            this.mainService.SuccessToast('Note Added for the Unit');
          });
        } else {
          result.client_id = id;
          (result.expiry_date = this.pipe.transform(new Date(), 'YYYY-MM-dd')),
            console.log(result);
          this.rest.addNoteForClient(result).subscribe((res: any) => {
            console.log(res);
            this.unit_data();
            this.mainService.SuccessToast('Note Added for the client');
          });
        }
      }
    });
  }

  blockUnitGates(id: any) {
    let unitOrClientID: any;
    let unitOrCclientName: any;
    if (id != null) {
      unitOrClientID = id;
      unitOrCclientName = 'client';
    } else {
      unitOrClientID = this.unitId;
      unitOrCclientName = 'unit';
    }
    const dialogRef = this.dialog.open(UnitBlockComponent, {
      width: '400px',
      data: { id: unitOrClientID, name: unitOrCclientName }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        if (id != null) {
          let data = {
            gates: result,
            clients: [id]
          };
          if (result.balckList.length != 0) {
            data.gates = result.balckList;
            this.rest.balckListForClient(data).subscribe((res: any) => {
              console.log(res);
              this.mainService.SuccessToast('Client add in blackList Gates');
            });
          } else {
            data.gates = result.WhiteList;
            console.log(data);
            this.rest.whiteListForClient(data).subscribe((res: any) => {
              console.log(res);
              this.mainService.SuccessToast('Client add in whiteList Gates');
            });
          }
        } else {
          let data = {
            gates: result,
            units: [this.unitId]
          };
          if (result.balckList.length != 0) {
            data.gates = result.balckList;
            this.rest.blockUnitForGate(data).subscribe((res: any) => {
              console.log(res);
              this.mainService.SuccessToast('unit add in blackList Gates');
            });
          } else {
            data.gates = result.WhiteList;
            console.log(data);
            this.rest.whiteListGateUnit(data).subscribe((res: any) => {
              console.log(res);
              this.mainService.SuccessToast('unit add in whiteList Gates');
            });
          }
        }
        console.log(result);
      }
    });
  }

  importClient() {
    const dialogRef = this.dialog.open(ImportClientComponent, {
      width: '450px'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        let data = {
          unit_id: this.unitId,
          clients: result
        };
        this.rest.importClient(data).subscribe((res: any) => {
          console.log(res);
          this.mainService.SuccessToast('Clients import');
          this.unit_data();
        });
        console.log(result);
      }
    });
  }

  openBlockClient(title: any, item: any) {
    if (title == 'block') {
      this.blockClientTitle = 'Block';
    } else {
      this.blockClientTitle = 'Active';
    }
    this.clientIdDeleted = item.id;
    const button: any = document.getElementById('btn4');
    button.click();
  }

  blockClient() {
    let data = {
      id: this.clientIdDeleted,
      cancelled: true
    };
    if (this.blockClientTitle == 'Block') {
      data.cancelled = true;
    } else {
      data.cancelled = false;
    }
    this.clientService.editClient(data).subscribe((res: any) => {
      console.log(res);
      if (this.blockClientTitle == 'Block') {
        this.mainService.SuccessToast('Client Blocked');
      } else {
        this.mainService.SuccessToast('Client Active');
      }
      this.unit_data();
    });
  }

  genrateInvtaion(value: any) {
    const dialogRef = this.dialog.open(InvtaionComponent, {
      width: '450px',
      data: {
        unitName: this.unit_name,
        clientName: value.name,
        unitId: this.unitId
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        result.data.unit_id = this.unitId;
        result.data.client_id = value.id;
        result.data.valid_from = this.pipe.transform(
          result.data.valid_from,
          'YYYY-MM-dd hh:mm:ss'
        );
        result.data.valid_to = this.pipe.transform(
          result.data.valid_to,
          'YYYY-MM-dd hh:mm:ss'
        );
        if (result.value == 'normal') {
          console.log(result.data);
          this.rest.clientInvtaion(result.data).subscribe(
            (res: any) => {
              if (res.status == false) {
                this.mainService.erorrToast(res.message);
              } else {
                let data: any = result;
                data.qrName = res.qr_code;
                data.unitName = this.unit_name;
                (data.inviter = value.name), this.openQr(data);
                console.log(res);
              }
            },
            (err: any) => {
              this.mainService.erorrToast('somthing erorr');
            }
          );
        } else {
          console.log(result);
          this.rest.clientSmsInvite(result.data).subscribe(
            (res: any) => {
              console.log(res);
            },
            (err: any) => {
              this.mainService.erorrToast('somthing erorr');
            }
          );
        }
      }
    });
  }

  openQr(value: any) {
    const dialogRef = this.dialog.open(QrInvtationComponent, {
      width: '350px',
      data: value
    });
  }

  addCard(value: any) {
    const dialogRef = this.dialog.open(AddCardComponent, {
      width: '450px',
      data: { id: value.id }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        if (result.license_plate) {
          result.unit_id = this.unitId;
          result.client_id = value.id;
          this.rest
            .addRfid(result)
            .then(response => response.text())
            .then(result => {
              let res = JSON.parse(result);
              if (res.status == true) {
                this.mainService.SuccessToast('RFID Added');
              } else {
                this.mainService.erorrToast('Opss somthing worng happen!');
              }
              console.log(result);
            })
            .catch(error => {
              this.mainService.erorrToast('Opss somthing worng happen!');
            });
        } else {
          result.client_id = value.id;
          this.rest.addCard(result).subscribe((res: any) => {
            console.log(res);
            this.activeClient(value.id);
            this.mainService.SuccessToast('Card Added');
          });
        }
        console.log(result);
      }
    });
  }
  dataPrint: any = [];
  print_card(data: any) {
    this.dataPrint = [];
    if (data == 'all') {
      this.unit_clients.forEach((element: any) => {
        if (element.printed != true) {
          let object_data: any = {
            name: element.name,
            unitName: this.unit_name,
            villageName: this.cardObject.villageName,
            image1: this.cardObject.image1
          };
          if (element.type.name == 'Main Owner' || element.type.name == "Owner") {
            object_data.type = 'owner' + "'s" + ' ' + 'Card';
            object_data.status = true
          } else {
            object_data.type = element.type.name + "'s" + ' ' + 'Card';
            object_data.status = false
          }

          if (element.photo) {
            object_data.image = element.photo;
          } else {
            object_data.image = 'assets/images/avatar.png';
          }

          if(element.type.name == 'Main Owner' || element.type.name == 'Owner'){
            object_data.image1 = this.imageBase641
          }else {
            object_data.image1 = this.imageBase64
          }
          
          this.dataPrint.push(object_data);
          this.clientService
            .printCardForClient(element.id)
            .subscribe((res: any) => {
              console.log(res);
            });
        }
      });
      console.log(this.dataPrint);
      setTimeout(() => {
        if (this.dataPrint.length == 0) {
          this.mainService.erorrToast('Already Printed');
        } else {
          const button: any = document.getElementById('printButton');
          button.click();
          this.mainService.SuccessToast('Printed success');
          this.unit_data();
          window.onafterprint = function() {
            console.log('printer');
          };
        }
      }, 200);
    } else {
      console.log(data);
      this.cardObject.name = data.name;
      if (data.type.name == 'Main Owner') {
        this.cardObject.type = 'owner' + "'s" + ' ' + 'Card';
      } else {
        this.cardObject.type = data.type.name + "'s" + ' ' + 'Card';
      }
      
      this.cardObject.validFrom = data.valid_from;
      this.cardObject.validTo = data.valid_to;
      this.cardObject.unitName = this.unit_name;
      if (data.photo) {
        this.cardObject.image = data.photo;
      } else {
        this.cardObject.image = 'assets/images/avatar.png';
      }

      if(data.type.name == 'Main Owner' || data.type.name == 'Owner'){
        this.cardObject.image1 = this.imageBase641
        this.cardObject.status = true
      }else {
        this.cardObject.image1 = this.imageBase64
        this.cardObject.status = false
      }
      this.dataPrint.push(this.cardObject);
      console.log(this.dataPrint)

      setTimeout(() => {
        this.clientService.printCardForClient(data.id).subscribe((res: any) => {
          console.log(res);
          this.mainService.SuccessToast('Printed success');
          this.unit_data();
        });
        const button: any = document.getElementById('printButton');
        button.click();
        window.onafterprint = function() {
          console.log('printer');
        };
      }, 200);
    }
  }

  activeClient(value: any) {
    let data = {
      id: value + '',
      activated: true
    };
    this.clientService.editClient(data).subscribe((res: any) => {
      console.log(data);
      this.mainService.SuccessToast('Client Activated');
      this.unit_data();
    });
    console.log(data);
  }
  activityLog(){
    this.route.navigate(["pages/activty_logs",this.unitId])
  }

  invoices(){
    this.route.navigate(["pages/unit_invoice",this.unitId,this.unit_name])
  }
}

// var mywindow: any = window.open();
// const selectProtected: SelectProtected = {
//   wrapperElement: document.getElementById('cardPrint')
// };
// var divDta:selectProtected = document.getElementById('cardPrint');
// divDta.innerHTML
// console.log(divDta)
// mywindow.document.write('<html><head>');
// mywindow.document.write('</head><body >');
// mywindow.document.write(selectProtected.wrapperElement.innerHTML);
// mywindow.document.write('</body></html>');

// mywindow.document.close();
// mywindow.focus();
// mywindow.print();
// mywindow.close();
